// ignore-string-externalization

import React from 'react';
import { ContentfulAsset } from '../../Contentful';
import { ModuleType } from '../types';
import { useLocale } from '@spotify-internal/i18n-core';
import {
  FeaturedContentModule as FrodorFeaturedContentModule,
  ContentItem,
  Colors,
} from '@spotify-internal/frodor-modules';
import { GridItem } from '../LinkGridModule/LinkGridFields';
import { toContentItem } from '../LinkGridModule/toContentItem';
import { isValidGridItem } from './validation';
import { getHeroData } from './heroData';

type FeaturedContentModuleType = {
  caption?: string;
  headline?: string;
  image?: ContentfulAsset;
  gridSupertext?: string;
  heroSupertext?: string;
  theme?: string;
  articleLink?: ModuleType;
  linkGrid?: {
    items: GridItem[];
  };
  gridColors: Colors;
  heroColors: Colors;
};

export const FeaturedContentModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  FeaturedContentModuleType
>(
  (
    {
      caption = '',
      gridSupertext = '',
      heroSupertext = '',
      theme = '',
      articleLink,
      linkGrid,
      gridColors,
      heroColors,
    },
    ref,
  ) => {
    const locale = useLocale();
    const hero = getHeroData(articleLink, locale);

    let linkGridItems: ContentItem[] = [];
    if (linkGrid && linkGrid.items && linkGrid.items.length > 0) {
      linkGridItems = linkGrid.items
        .filter(item => isValidGridItem(item, locale))
        .map(item => toContentItem(item))
        .filter(item => {
          // Additional check: ensure the converted item has a title (final validation)
          return item && item.title && item.url;
        });
    }

    return (
      <FrodorFeaturedContentModule
        theme={theme === 'whiteOnBlack' ? 'whiteOnBlack' : 'blackOnWhite'}
        contentType="featuredContentModule"
        contentItems={linkGridItems}
        gridSupertext={gridSupertext.toUpperCase()}
        hero={{
          title: hero?.title,
          url: hero?.url,
          image: hero?.image,
        }}
        heroSupertext={heroSupertext}
        caption={caption}
        gridColors={gridColors}
        heroColors={heroColors}
        ref={ref as any}
      />
    );
  },
);
